import { render, staticRenderFns } from "./Content_book.vue?vue&type=template&id=18d6a252&scoped=true"
import script from "./Content_book.vue?vue&type=script&lang=js"
export * from "./Content_book.vue?vue&type=script&lang=js"
import style0 from "./Content_book.vue?vue&type=style&index=0&id=18d6a252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d6a252",
  null
  
)

export default component.exports